import { render, staticRenderFns } from "./urunEkle.vue?vue&type=template&id=0c7dedfe&scoped=true"
import script from "./urunEkle.vue?vue&type=script&lang=js"
export * from "./urunEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7dedfe",
  null
  
)

export default component.exports